import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../../Button'
import { SelectDropdownEmpty } from '../../../../Select'
import {
  QA_NAME_VIEWING_FORM_NO_APPLICANTS_ACTION,
  VIEWING_FORM_FIELD_NAME,
  VIEWING_FORM_MODE,
  VIEWING_FORM_TIME_SOURCE,
} from '../../RentalPortalViewingFormModal.constants'

import * as styles from './ViewingFormApplicantSelectDropdownEmpty.module.css'

function ViewingFormApplicantSelectDropdownEmpty() {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  function handleClickAddSlot() {
    setFieldValue(VIEWING_FORM_FIELD_NAME.mode, VIEWING_FORM_MODE.addSlot)

    setFieldValue(
      VIEWING_FORM_FIELD_NAME.timeSource,
      VIEWING_FORM_TIME_SOURCE.adHoc
    )

    setFieldValue(VIEWING_FORM_FIELD_NAME.slot, null)
  }

  return (
    <div className={styles.ViewingFormApplicantSelectDropdownEmpty}>
      <SelectDropdownEmpty
        className={styles.message}
        text={t('RentalPortal.ViewingFormNoApplicantsKey')}
      />
      <Button.Text
        className={styles.action}
        qaName={QA_NAME_VIEWING_FORM_NO_APPLICANTS_ACTION}
        text={t('RentalPortal.ViewingFormNoApplicantsActionKey')}
        onClick={handleClickAddSlot}
      />
    </div>
  )
}

export default ViewingFormApplicantSelectDropdownEmpty
